import { checkIsMobile } from './helpers';
import renderDesktopAuthElsInHeader from './header/desktop/index';
import renderMobileAuthElsInHeader from './header/mobile/index';
import userState from './userState';


/**
 * Функция рендерит элементы авторизации для пользователя в шапку сайта
 */
export const renderAuthElementsInHeader = () => {
  const isMobile = checkIsMobile();
  if (!isMobile) {
    renderDesktopAuthElsInHeader(userState);
  } else {
    renderMobileAuthElsInHeader(userState);
  }
};




// WEBPACK FOOTER //
// ./daily/assets/id/ui.js